<div class="product-variants-container" id="variants-dialog">
  <div class="product-variants-header">
    <div class="header-title">
      {{'text_addProductsEditVariants'|dbText}}
    </div>
  </div>
  <div class="product-variants-list-container">
    <div class="variations-table-tools">
      <div class="variations-count">
        <div>{{ 'text_allVariations' | dbText }}</div>
        <div class="count">{{variantsFormArray.controls.length}}</div>
      </div>
      <div class="separator"></div>
      <div class="variations-search">
        <i class="db-icon db-icon-ds-seo-new"></i>
        <input [placeholder]="'text_searchEllipsis' | dbText"
               (focus)="searchFocused = true"
               (click)="searchFocused = true"
               (blur)="hideDropdown()"
               [formControl]="searchTerm">
        <div class="search-dropdown-container"
             *ngIf="mainSearchOptions.length && searchFocused && searchTerm.value">
          <div class="search-option"
               (click)="selectOption(option)"
               *ngFor="let option of mainSearchOptions">
            {{option}}
          </div>
        </div>
      </div>
      <div class="separator"></div>
      <div class="variations-selected">
        <div>{{ 'text_selected' | dbText }}</div>
        <div class="count">{{checkedControls.length}}</div>
      </div>
      <div class="separator"></div>
      <div class="variations-edit-tools" [class.active]="!!checkedControls.length">
        <div class="variations-edit-tool"
             [dsTooltip]="EDIT_PRICE"
             [dsTooltipSize]="'large'"
             [dsTooltipMode]="'click'">
          Edit price
        </div>
        <ng-template #EDIT_PRICE>
          <db-product-batch-edit
            [symbol]="currencySymbol.symbol"
            (saveValue)="batchEditPrice($event)"
            [title]="'Enter a price for the selected<br> variants:'">
          </db-product-batch-edit>
        </ng-template>
        <div class="variations-edit-tool"
             *ngIf="track_stock"
             [dsTooltip]="INVENTORY"
             [dsTooltipSize]="'large'"
             [dsTooltipMode]="'click'">
          Set stock quantity
        </div>
        <ng-template #INVENTORY>
          <db-product-batch-edit
            [type]="'inventory'"
            (saveValue)="batchEditInventory($event)"
            [title]="'Add stock quantities<br> for the selected variants:'">
          </db-product-batch-edit>
        </ng-template>

        <div class="variations-edit-tool"
             *ngIf="!track_stock">
          <span (click)="showEditStatus = true;">{{ 'text_editStockStatus' | dbText }}</span>
          <db-product-batch-edit
            (dbClickOutside)="showEditStatus = false;"
            [outsideClass]="'ds-dropdown-list'"
            [disablePropagation]="false"
            *ngIf="showEditStatus"
            [type]="'status'"
            [statusOptions]="statusOptions"
            (saveValue)="batchEditStatus($event)"
            [title]="'Choose an inventory status<br> for the selected variants:'">
          </db-product-batch-edit>
        </div>

        <div class="variations-edit-tool"
             *ngIf="track_stock">
          <span (click)="showEditBOStatus = true;">{{ 'text_editBackorderStatus' | dbText }}</span>
          <db-product-batch-edit
            (dbClickOutside)="showEditBOStatus = false;"
            [disablePropagation]="false"
            [outsideClass]="'ds-dropdown-list'"
            *ngIf="showEditBOStatus"
            [type]="'status'"
            [statusOptions]="backorderStatusOptions"
            (saveValue)="batchEditBackorderStatus($event)"
            [title]="'Choose an inventory status<br> for the selected variants:'">
          </db-product-batch-edit>
        </div>
        <div class="variations-edit-tool"
             [dsTooltip]="DIMENSIONS"
             [dsTooltipSize]="'large'"
             [dsTooltipMode]="'click'">
          Shipping measurement
        </div>
        <ng-template #DIMENSIONS>
          <db-product-batch-edit
            [type]="'dimensions'"
            [statusOptions]="statusOptions"
            (saveValue)="batchEditDimensions($event)"
            [title]="'Set shipping measurement for the selected variants:'">
          </db-product-batch-edit>
        </ng-template>
        <div class="variations-edit-tool" (click)="batchHide()">
          Hide variations
        </div>
      </div>
    </div>
    <div class="table">
      <div class="variants-table-row heads" [class.shorten]="!track_stock">
         <span>
            <input type="checkbox"
                   [ngClass]="{'ds-checkbox-partly': variantsCheckboxPartiallyChecked}"
                   [checked]="allVariantsCheckboxChecked || variantsCheckboxPartiallyChecked"
                   #check
                   (click)="onMainCheckboxChange(check.checked)"
                   class="ds-checkbox"
                   id="variants-check">
            <label for="variants-check" class="ds-checkbox-label black"></label>
         </span>
        <span *ngFor="let head of heads" [innerHTML]="head"></span>
      </div>
      <div class="list" [class.short]="!!hiddenVariations.length" [formGroup]="variantsForm">
        <ng-container formArrayName="variants">
          <ng-container *ngFor="let variant of variantsFormArray.controls; let i = index">
            <section class="table-row"
                     [class.shorten]="!track_stock"
                     [class.hide]="variant.get('status').value === ProductVariantStatus.PRIVATE || !variant.get('show').value"
                     [ngClass]="variant.get('status').value">
              <ng-container [formGroup]="$any(variant)">
                <div class="variant-option-container row-item">
                 <span>
                    <input type="checkbox"
                           formControlName="checked"
                           (change)="onCheckboxClick()"
                           class="ds-checkbox" [id]="i">
                    <label [for]="i" class="ds-checkbox-label black"></label>
                 </span>
                </div>
                <div class="product-number row-item">
                  #{{variant.get('index').value + 1}}
                </div>
                <div class="product-image row-item">
                  <div class="image-container" (click)="openMedia(variant)"
                       *ngIf="!variant.get('image').value;else imageCont">
                    <i class="db-icon db-icon-ds-bold-download"></i>
                  </div>
                  <ng-template #imageCont>
                    <div class="image-container empty" (click)="openMedia(variant)">
                      <img [src]="variant.get('image').value?.src || variant.get('image').value?.source_url"/>
                    </div>
                  </ng-template>
                </div>
                <div class="product-terms-container row-item">
                <span *ngFor="let term of variant.get('options').value">
                  {{term.name}}
                </span>
                </div>
                <div class="variant-option-container row-item">
                  <ds-dropdown
                    *ngIf="!track_stock; else stockQ"
                    [formControl]="variant.get('stock_status')|toFormControl"
                    [dsDropdownOptions]="statusOptions">
                  </ds-dropdown>
                  <ng-template #stockQ>
                    <input class="ds-input"
                           [class.disabled]="variant.get('status').value === ProductVariantStatus.PRIVATE"
                           type="text"
                           formControlName="stock_quantity"
                           placeholder="">
                  </ng-template>
                </div>
                <div class="variant-option-container row-item" *ngIf="track_stock">
                  <ds-dropdown
                    [formControl]="variant.get('backorder_status')|toFormControl"
                    [dsDropdownOptions]="backorderStatusOptions">
                  </ds-dropdown>
                </div>
                <div class="variant-option-container row-item">
                  <input class="ds-input"
                         [class.disabled]="variant.get('status').value === ProductVariantStatus.PRIVATE"
                         type="text"
                         formControlName="sku"
                         placeholder="">
                </div>
                <div class="variant-option-container row-item">
                  <input class="ds-input"
                         [class.disabled]="variant.get('status').value === ProductVariantStatus.PRIVATE"
                         formControlName="price"
                         appCurrencyMask
                         [symbol]="currencySymbol.symbol"
                         type="text"
                         [placeholder]="currencySymbol.symbol + ' 0.00'">
                </div>
                <div class="variant-option-container row-item">
                  <input class="ds-input"
                         [class.disabled]="variant.get('status').value === ProductVariantStatus.PRIVATE"
                         formControlName="sale_price"
                         appCurrencyMask
                         [symbol]="currencySymbol.symbol"
                         type="text"
                         [placeholder]="currencySymbol.symbol + ' 0.00'">
                </div>
                <div class="variant-option-container row-item">
                  <input class="ds-input"
                         [class.disabled]="variant.get('status').value === ProductVariantStatus.PRIVATE"
                         type="text"
                         appCurrencyMask
                         [otherMeasurement]="measurements.weight_unit"
                         formControlName="weight"
                         [placeholder]="'0 '+measurements.weight_unit">
                </div>
                <div class="variant-option-container row-item">
                  <input class="ds-input"
                         [class.disabled]="variant.get('status').value === ProductVariantStatus.PRIVATE"
                         type="text"
                         appCurrencyMask
                         [otherMeasurement]="measurements.dimension_unit"
                         formControlName="length"
                         [placeholder]="'0 '+measurements.dimension_unit">
                </div>
                <div class="variant-option-container row-item">
                  <input class="ds-input"
                         [class.disabled]="variant.get('status').value === ProductVariantStatus.PRIVATE"
                         type="text"
                         appCurrencyMask
                         [otherMeasurement]="measurements.dimension_unit"
                         formControlName="height"
                         [placeholder]="'0 '+measurements.dimension_unit">
                </div>
                <div class="variant-option-container row-item">
                  <input class="ds-input"
                         [class.disabled]="variant.get('status').value === ProductVariantStatus.PRIVATE"
                         type="text"
                         appCurrencyMask
                         [otherMeasurement]="measurements.dimension_unit"
                         formControlName="width"
                         [placeholder]="'0 '+measurements.dimension_unit">
                </div>
                <div class="variant-status-container row-item">
                  <i class="db-icon db-icon-eye"
                     [dsTooltip]="'Hide'"
                     dsTooltipPosition="right"
                     dsTooltipColor="black"
                     dsTooltipAlign="top"
                     *ngIf="variant.get('status').value === ProductVariantStatus.PUBLISH"
                     (click)="variant.get('status').setValue(ProductVariantStatus.PRIVATE)"
                  ></i>
                  <i class="db-icon db-icon-eye-hide"
                     [dsTooltip]="'Show'"
                     dsTooltipPosition="right"
                     dsTooltipColor="black"
                     dsTooltipAlign="top"
                     *ngIf="variant.get('status').value === ProductVariantStatus.PRIVATE"
                     (click)="variant.get('status').setValue( ProductVariantStatus.PUBLISH)"></i>
                </div>
              </ng-container>
            </section>
          </ng-container>
        </ng-container>
      </div>
    </div>

  </div>
  <div class="hidden-variations-container" *ngIf="hiddenVariations.length">
    <div class="product-variants-list-container">
      <div class="variations-table-tools">
        <div class="variations-count">
          <div>{{ 'text_hiddenVariations' | dbText }}</div>
          <div class="count">{{hiddenVariations.length}}</div>
        </div>
        <div class="separator"></div>
        <div class="variations-search">
          <i class="db-icon db-icon-ds-seo-new"></i>
          <input [placeholder]="'text_searchEllipsis' | dbText" [formControl]="hiddenSearchTerm">
        </div>
        <div class="separator"></div>
        <div class="variations-selected">
          <div>{{ 'text_selected' | dbText }}</div>
          <div class="count">{{hiddenCheckedControls.length}}</div>
        </div>
        <div class="separator"></div>
        <div class="variations-edit-tools" [class.active]="hiddenCheckedControls.length">
          <div class="variations-edit-tool" (click)="batchHide(ProductVariantStatus.PUBLISH, hiddenCheckedControls)">
            Show hidden variations
          </div>
        </div>
      </div>
      <div class="table">
        <div class="variants-table-row heads">
         <span>
            <input type="checkbox"
                   [ngClass]="{'ds-checkbox-partly': hiddenVariantsCheckboxPartiallyChecked}"
                   [checked]="allHiddenVariantsCheckboxChecked || hiddenVariantsCheckboxPartiallyChecked"
                   #check2
                   (click)="onMainHiddenCheckboxChange(check2.checked)"
                   class="ds-checkbox"
                   id="hidden-variants-check">
            <label for="hidden-variants-check" class="ds-checkbox-label black"></label>
         </span>
          <span *ngFor="let head of heads" [innerHTML]="head"></span>
        </div>
        <div class="list" [formGroup]="variantsForm">
          <ng-container formArrayName="variants">
            <ng-container *ngFor="let variant of hiddenVariations; let i = index">
              <section class="table-row"
                       [class.hide]="!variant.get('show').value"
                       [ngClass]="variant.get('status').value">
                <ng-container [formGroup]="$any(variant)">
                  <div class="variant-option-container row-item keep">
                 <span>
                    <input type="checkbox"
                           formControlName="checked_hidden"
                           (change)="onHiddenCheckboxClick()"
                           class="ds-checkbox" [id]="i+'h'">
                    <label [for]="i+'h'" class="ds-checkbox-label black"></label>
                 </span>
                  </div>
                  <div class="product-number row-item keep">
                    #{{variant.get('index').value + 1}}
                  </div>
                  <div class="product-image row-item">
                    <div class="image-container" (click)="openMedia(variant)"
                         *ngIf="!variant.get('image').value;else imageCont">
                      <i class="db-icon db-icon-ds-bold-download"></i>
                    </div>
                    <ng-template #imageCont>
                      <div class="image-container empty" (click)="openMedia(variant)">
                        <img [src]="variant.get('image').value?.src || variant.get('image').value?.source_url"/>
                      </div>
                    </ng-template>
                  </div>
                  <div class="product-terms-container row-item">
                <span *ngFor="let term of variant.get('options').value">
                  {{term.name}}
                </span>
                  </div>
                  <div class="variant-option-container row-item">
                    <ds-dropdown
                      *ngIf="!track_stock; else stockQ"
                      [formControl]="variant.get('stock_status')|toFormControl"
                      [dsDropdownOptions]="statusOptions">
                    </ds-dropdown>
                    <ng-template #stockQ>
                      <input class="ds-input"
                             type="text"
                             formControlName="stock_quantity"
                             placeholder="">
                    </ng-template>
                  </div>
                  <div class="variant-option-container row-item" *ngIf="track_stock">
                    <ds-dropdown
                      [formControl]="variant.get('backorder_status')|toFormControl"
                      [dsDropdownOptions]="backorderStatusOptions">
                    </ds-dropdown>
                  </div>
                  <div class="variant-option-container row-item">
                    <input class="ds-input"
                           type="text"
                           formControlName="sku"
                           placeholder="">
                  </div>
                  <div class="variant-option-container row-item">
                    <input class="ds-input"
                           formControlName="price"
                           appCurrencyMask
                           [symbol]="currencySymbol.symbol"
                           type="text"
                           [placeholder]="currencySymbol.symbol + ' 0.00'">
                  </div>
                  <div class="variant-option-container row-item">
                    <input class="ds-input"
                           formControlName="sale_price"
                           appCurrencyMask
                           [symbol]="currencySymbol.symbol"
                           type="text"
                           [placeholder]="currencySymbol.symbol + ' 0.00'">
                  </div>
                  <div class="variant-option-container row-item">
                    <input class="ds-input"
                           type="text"
                           numbersOnly
                           appCurrencyMask
                           [otherMeasurement]="measurements.weight_unit"
                           formControlName="weight"
                           [placeholder]="'0 '+measurements.weight_unit">
                  </div>
                  <div class="variant-option-container row-item">
                    <input class="ds-input"
                           type="text"
                           numbersOnly
                           appCurrencyMask
                           [otherMeasurement]="measurements.dimension_unit"
                           formControlName="length"
                           [placeholder]="'0 '+measurements.dimension_unit">
                  </div>
                  <div class="variant-option-container row-item">
                    <input class="ds-input"
                           type="text"
                           numbersOnly
                           appCurrencyMask
                           [otherMeasurement]="measurements.dimension_unit"
                           formControlName="height"
                           [placeholder]="'0 '+measurements.dimension_unit">
                  </div>
                  <div class="variant-option-container row-item">
                    <input class="ds-input"
                           type="text"
                           numbersOnly
                           appCurrencyMask
                           [otherMeasurement]="measurements.dimension_unit"
                           formControlName="width"
                           [placeholder]="'0 '+measurements.dimension_unit">
                  </div>
                </ng-container>
              </section>
            </ng-container>

          </ng-container>
        </div>
      </div>

    </div>
  </div>
  <div class="product-variants-actions-container">
    <div class="track-stock-container">
      <input [checked]="track_stock" (change)="onTrackStockChange()" type="checkbox" class="ds-checkbox"
             id="track-stock">
      <label for="track-stock" class="ds-checkbox-label black">
        Track stock quantity for this product
      </label>
      <i class="db-icon db-icon-ds-info-bg"
         [dsTooltip]="'text_productsStockAmount'|dbText"
         dsTooltipPosition="right"
         dsTooltipColor="black"
         dsTooltipAlign="top"></i>
    </div>
    <div class="actions">
      <a class="ds-btn ds-btn-small"
         (click)="resetForm()">
        {{'text_reset' | dbText}}
      </a>
      <a class="ds-btn-black ds-btn-small"
         (click)="saveVariants()"
         [ngClass]="{'db-button_disabled': variantsForm.invalid}">
        <span>{{'text_saveTags' | dbText}}</span>
      </a>
    </div>

  </div>
</div>
